import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { findItemValueByIdFromArray } from "helpers/find-item-by-id-from-array";
import SearchSelect from "views/lib/components/SearchSelect";
import {
  packageGetList
} from "actions/package/actions";

const ModalPackage = ({
                        packageGetList,
                        packageList,
                        onSubmit,
                        onCancel
                      }) => {
  const [currentPackageId, setCurrentPackageId] = useState(null);

  const handleChange = (option) => {
    setCurrentPackageId(option ? option.value : null);
  };

  const handleSubmit = () => {
    const pack = packageList.find(item => item.id === currentPackageId);
    if (!pack) return;
    onSubmit(pack);
  };

  const packOptions = packageList.map(item => ({
    label: item.code,
    value: item.id
  }));

  const packSelected = findItemValueByIdFromArray(
    packOptions,
    "value",
    currentPackageId
  ) || null;

  useEffect(() => {
    packageGetList();
  }, [packageGetList]);

  return (
    <div>
      <div className="form-group">
        <label>Package</label>
        <SearchSelect
          className="search-select"
          onChange={handleChange}
          options={packOptions}
          isSearchable={true}
          isClearable={false}
          value={packSelected}
          isLoading={false}
        />
      </div>
      <div className="text-right">
        <button
          className="btn btn-danger mr-2"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={!currentPackageId}
        >
          Save
        </button>
      </div>
    </div>
  );
};

/*
class ModalPackage extends React.Component {
    format = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            currentPackageId: this.props.currentPackageId || null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.packageGetList();
    }

    handleChange = (option) => {
        this.setState({
            currentPackageId: option ? option.value : null
        });
    };

    handleSubmit = () => {
        const {
            packageList,
        } = this.props;
        const pack = packageList.find(item => item.id === this.state.currentPackageId);
        if (!pack) {
            return;
        }
        this.props.onSubmit(pack);
    };

    render() {
        const {
            packageList,
        } = this.props;
        const { currentPackageId } = this.state;

        const packOptions = packageList.map(item => ({
            label: item.name,
            value: item.id
        }));

        const packSelected = findItemValueByIdFromArray(
            packOptions,
            "value",
            currentPackageId
        ) || null;

        return (
            <div>
                <div className="form-group">
                    <label>Package</label>
                    <SearchSelect
                        className="search-select"
                        onChange={this.handleChange}
                        options={packOptions}
                        isSearchable={true}
                        isClearable={false}
                        value={packSelected}
                        isLoading={false}
                    />
                </div>
                <div className="text-right">
                    <button
                        className="btn btn-danger mr-2"
                        onClick={this.props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.handleSubmit}
                        disabled={!currentPackageId}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}
*/

ModalPackage.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  currentPackageId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  packageList: state.package.packageList,
});

const mapStateToDispatch = dispatch => ({
  packageGetList: bindActionCreators(packageGetList, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ModalPackage);



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-package.js